import angular from 'angular';
import Country from './country';
import Environment from './environment';
import Language from './language';
import RouterProvider from './router-provider';

export default angular
    .module('paysera.environment.services', [])
    .service('country', Country)
    .service('environment', Environment)
    .service('language', Language)
    .provider('router', RouterProvider)
    .name
;
